import styled from "@emotion/styled";
import theme from "../../../UI/theme";

const tableBorder = `1px solid ${theme.colors.lightGray}`;

export const CarouselWrapper = styled.div`
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    padding: 2rem;
`;

export const CalendarHeaderWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: 1.5rem;
`;

export const Arrow = styled.div`
    padding: 0.5rem 1rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    & svg {
        font-weight: 900;
        font-size: 24px;
        color: ${theme.colors.primary};
    }
`;
export const WeekIntervalContainer = styled.div`
    display: flex;
    color: ${theme.colors.gray};
    gap: 1.25rem;
    & .react-datepicker-wrapper {
        width: min-content;
        transform: scale(1.2);
        color: ${theme.colors.gray};
        opacity: 0.9;
        cursor: pointer;
    }
    & .react-datepicker__tab-loop {
        position: absolute;
        font-size: 12px;
        font-weight: 400;
    }
    & .react-datepicker__header {
        background-color: white;
        border: none;
        padding: 0.75rem 0 0 0;
    }
    & .react-datepicker__triangle::after {
        border-bottom-color: white !important;
    }
    & .react-datepicker__navigation {
        top: 0.75rem;
    }
    & .react-datepicker__week-number {
        color: ${theme.colors.primary};
        font-weight: 600;
    }
    & .react-datepicker__day--keyboard-selected {
        background-color: ${theme.colors.primary};
    }

    & .react-datepicker__day-name {
        font-weight: 600;
    }
    & .react-datepicker__week > div:first-of-type {
        border-right: 1px solid ${theme.colors.gray};
        margin: 0;
        padding: 0.166rem;
    }
`;

export const WeekNumber = styled.div<{ isSettings: boolean }>`
    color: ${(props) =>
        props.isSettings ? theme.colors.gray : theme.colors.primary};
`;

export const WeeksContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 450px;
    flex: 1;
    gap: 0.5rem;
    & > div {
        font-weight: ${theme.typography.fontWeight.semibold};
        font-size: 18px;
    }
`;

export const TimeCellWrapper = styled.div<{
    isConsultation: boolean;
    isReservation: boolean;
}>`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 18px;
    font-size: 14px;
    background-color: ${(props) =>
        props.isReservation
            ? theme.colors.red
            : props.isConsultation
            ? theme.colors.green
            : "unset"};
    cursor: ${(props) => (props.isReservation ? "pointer" : "default")};
    &:not(:last-of-type) {
        border-bottom: ${tableBorder};
    }
`;

export const WeekDayWrapper = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    &:not(:last-of-type) {
        border-right: ${tableBorder};
    }
`;

export const ColumnHead = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    border-bottom: ${tableBorder};
    flex: 1;
    & div {
        &:first-of-type {
            font-weight: ${theme.typography.fontWeight.semibold};
            color: ${theme.colors.gray};
            text-transform: capitalize;
        }
        &:last-child {
            font-weight: ${theme.typography.fontWeight.thin};
            font-size: 13px;
        }
    }
`;

export const CalendarBodyWrapper = styled.div<{ isSettings: boolean }>`
    border: ${(props) => props.isSettings || tableBorder};
    border-radius: 20px;
    display: flex;
`;

export const ArrowPlaceHolder = styled.div`
    width: 47px;
`;

export const WeekDaysBox = styled.div`
    display: flex;
    width: 100%;
`;
